module.exports = __webpack_public_path__ + "media/images/d_analyze_portfolio-473f858c374fec03519ec90ef97c47ab.svg";